import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import NearbyBinsMap from '../../components/Map/NearbyBinsMap';
import './NearbyBinsPage.css';

const NearbyBinsPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, role } = useAuth();

  // Check authentication and role on component mount
  useEffect(() => {
    if (!isAuthenticated) {
      toast.error('Please login to access Nearby Bins');
      localStorage.setItem('redirectAfterLogin', '/nearby-bins');
      navigate('/signin');
      return;
    }
    
    // Only allow users to access nearby bins
    if (role !== 'user') {
      toast.error('Only User can access this feature');
      navigate('/');
      return;
    }
  }, [isAuthenticated, role, navigate]);
  
  useEffect(() => {
    if (!isAuthenticated || role !== 'user') {
      return;
    }
  }, [isAuthenticated, role]);

  return (
    <div className="nearby-bins-page">
      <div className="page-header">
        <button 
          onClick={() => navigate(-1)} 
          className="back-button"
        >
          <ArrowLeft size={20} />
          Back
        </button>
        <h1>Find Nearby Bins</h1>
      </div>

      <div className="content-container">
        <NearbyBinsMap />
      </div>
    </div>
  );
};

export default NearbyBinsPage;
